import { mobileXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled, { css } from 'styled-components';
import { Heading } from '../typography';

interface QuestionStyleProps {
  open: boolean | undefined;
}

export const FaqWrapper = styled.div`
  margin: 90px auto 115px auto;

  @media (${mobileXLargeMax}) {
    ${Heading} {
      font-size: 25px;
    }
  }
`;

export const QuestionWrapper = styled.button`
  display: block;
  cursor: pointer;
  width: 100%;
  text-align: left;
`;

export const QuestionTitle = styled.h4<QuestionStyleProps>`
  text-transform: none;
  padding: 20px 50px 20px 0px;
  color: ${(props) => props.theme.textDark};
  position: relative;
  line-height: 1.4;
  outline: none;
  font-size: 20px;

  ${({ open }) =>
    !open
      ? css`
          border-bottom: 1px solid ${(props) => props.theme.backgroundLight};
        `
      : ''}

  @media (${mobileXLargeMax}) {
    font-size: 18px;
  }
`;

export const IconWrapper = styled.div`
  display: block;
  width: 23px;
  height: 20px;
  position: absolute;
  right: 8px;
  top: 22px;
`;

export const ContentWrapper = styled.div<QuestionStyleProps>`
  display: inline-block;
  padding: 15px 0;
  ${(props) =>
    props.open
      ? css`
          border-bottom: 1px solid ${props.theme.backgroundLight};
        `
      : ``};
  width: 100%;
`;
